import { render, staticRenderFns } from "./CapabilityDonut.vue?vue&type=template&id=34193f78&"
import script from "./CapabilityDonut.vue?vue&type=script&lang=js&"
export * from "./CapabilityDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports